<template>
    <div @click="closeFilters()" class="filters-page" :class="isSticking ? 'sticky' : ''">
        <div v-on:click.stop class="filters-page-container">
            <div class="filter-header">
                <p>Filters <span v-if="totalCurrentFilters > 0">({{totalCurrentFilters}})</span></p>
                <img @click="closeFilters()" class="x" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x"/>
            </div>
            <div class="filters-container">
                <CategoriesFilter/>
                <OccasionFilter/>
                <PriceFilter v-if="maxMinPrices" :prices="maxMinPrices"/>
                <GenericFilter :filteredAddons="currentMobileAddons" :filters="filters" v-for="filters in mappedFilters" :key="filters.category"/>
            </div>
            <div class="button-container">
                <button @click="resetFilters" class="happybox-button white border">Reset</button>
                <button @click="applyFilters" class="happybox-button green border">Apply</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OccasionFilter from '../MobileFilters/OccasionFilterMobile.vue';
import CategoriesFilter from '../MobileFilters/CategoriesFilterMobile.vue';
import PriceFilter from '../MobileFilters/PriceFilterMobile.vue';
import GenericFilter from '../MobileFilters/GenericFilterMobile.vue';
export default {
    components: {
        OccasionFilter,
        CategoriesFilter,
        PriceFilter,
        GenericFilter,
    },
    data() {
        return{
        }
    },
    props:{
        filteredAddons: Array,
        filteredPreAddons: Array,
        isSticking: Boolean
    },
    computed: {
        ...mapGetters([
            'occasions',
            'categories',
            'addonProducts',
            'selectedFiltersMobile',
            'selectedCategoriesMobile',
            'rangePriceMobile',
            //True filters Start
            'selectedOccasion',
            'selectedCategories',
            'selectedSort',
            'selectedFilters',
            'rangePrice',
            //True filters END
        ]),
        selectedOccasionMobile: {
            get(){ return this.$store.state.selectedOccasionMobile},
            set(value){this.$store.commit('setSelectedOccasionMobile', value )}
        },
        selectedSortMobile: {
            get(){ return this.$store.state.selectedSortMobile},
            set(value){this.$store.commit('setSelectedSortMobile', value )}
        },
        currentOccasions(){
            return this.occasions;
        },
        mappedFilters(){
           var tags = [...new Set(this.addonProducts.flatMap(x => x.tags.filter(y => y.includes("Filter_") && !y.includes("Occasion") && !y.includes("Vibe"))))];
            if(tags.length > 0){
                tags = tags.map((x) =>{
                    const currentArray = x.replace("Filter_","").split("_");
                    if (currentArray.length > 1){
                        var currentObject = { category: currentArray[0], value: currentArray[1], tag: x };
                        return currentObject;
                    }
                })
                var sortedFilters = [];
                sortedFilters = [...tags.reduce((hash, {category,value,tag}) => {
                    const current = hash.get(category) || { category, filters: [] };
                    current.filters.push({ value, tag });
                    return hash.set(category, current);
                }, new Map).values()];

                return sortedFilters.filter(x => !x.category.includes("Occasions") && !x.category.includes("Category") && !x.category.includes("Arrival") && !x.category.includes("Badges") && !x.category.includes("Ethos"));
            }

            return [];
        },
        maxMinPrices(){
            var prices = this.currentMobilePreAddons.map(x => x.variants[0].price);
            if(prices.length > 0){
                var min = Math.floor(Math.min( ...prices )),
                max = Math.ceil(Math.max( ...prices ));

                return {min: min,max:max};
            }
            return null
        },
        currentMobilePreAddons(){
            let filterAddons =  JSON.parse(JSON.stringify(this.addonProducts));
            //filter via occasion
            if(this.selectedOccasionMobile.length > 0)
                filterAddons = filterAddons.filter(x => x.tags.some(y => y.includes(this.selectedOccasionMobile)));
            //Filter categories
            if(!this.selectedCategoriesMobile.includes("View All"))
                filterAddons = filterAddons.filter(x => x.tags.some(y =>  this.selectedCategoriesMobile.some(z => y.includes(z))));

            //Filter for each category
            for(let filter of this.selectedFiltersMobile){
                filterAddons = filterAddons.filter(x => filter.filters.every(y => x.tags.includes(y)));
            }
            
            return filterAddons;
        },
        currentMobileAddons(){
            return this.currentMobilePreAddons.filter(x => ((x.variants[0].price-this.rangePriceMobile.min)*(x.variants[0].price-this.rangePriceMobile.max) <= 0));
        },
        totalCurrentFilters(){
            let total = this.selectedOccasionMobile.length + this.selectedCategoriesMobile.filter(x => x != 'View All').length + this.selectedFiltersMobile.length;
            return total
        }
    },
    methods: {
        closeFilters(){
            //Reset the mobile filters to the true filters
            this.selectedSortMobile = this.selectedSort;
            this.$store.commit('setAllSelectedOccasionMobile', JSON.parse(JSON.stringify(this.selectedOccasion)))
            this.$store.commit('setAllSelectedCategoriesMobile', JSON.parse(JSON.stringify(this.selectedCategories)))
            this.$store.commit('setRangePriceMobile', JSON.parse(JSON.stringify(this.rangePrice)) )
            this.$store.commit('setTotalSelectedFiltersMobile', JSON.parse(JSON.stringify(this.selectedFilters)))
            this.$emit("closefilter");
        },
        resetFilters(){
            this.$emit("goall");
            this.$store.commit('setAllSelectedOccasion', [] )
            this.$store.commit('setSelectedSort', 1 )
            this.$store.commit('setAllSelectedCategories', ["View All"] )
            this.$store.commit('setRangePrice', {min:0,max:100} )
            this.$store.commit('setTotalSelectedFilters', [] )
            this.closeFilters();
        },
        applyFilters(){
            //Change the mobile filters to the true filters
            this.$emit("goall");
            this.logFilters();
            this.$store.commit('setAllSelectedOccasion', this.selectedOccasionMobile )
            this.$store.commit('setSelectedSort', this.selectedSortMobile )
            this.$store.commit('setAllSelectedCategories',JSON.parse(JSON.stringify(this.selectedCategoriesMobile)) )
            this.$store.commit('setRangePrice', JSON.parse(JSON.stringify(this.rangePriceMobile)))
            this.$store.commit('setTotalSelectedFilters', JSON.parse(JSON.stringify(this.selectedFiltersMobile)))
            this.$emit("closefilter");
        },
        logFilters(){
            ga('send', {
                hitType: 'event',
                eventCategory: 'Build A Box',
                eventAction: 'Filter Occasion',
                eventLabel: this.selectedOccasionMobile
            });
            ga('send', {
                hitType: 'event',
                eventCategory: 'Build A Box',
                eventAction: 'Filter Category',
                eventLabel: this.selectedCategoriesMobile
            });
            for(let filter in this.selectedFiltersMobile){
                ga('send', {
                    hitType: 'event',
                    eventCategory: 'Build A Box',
                    eventAction: `Filter ${filter.title}`,
                    eventLabel: filter.filters
                });
            }
        }
    }
}
</script>

<style scoped>
.filters-page{
    width: 100%;
    height: 100%;
    position: fixed;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 5;
    transition: height 0.5s;
    display: flex;
    justify-content: flex-end;
}
.filters-page-container{
    width: 75%;
    max-height: 100%;
    min-height: 100%;
    height: 100%;
    background-color: white;
    overflow-y: scroll;
    padding-bottom: 17%;
}

.filters-container{
    padding: 0% 5% 5% 5%;
}

.filter-header{
    box-shadow: inset 0px -1px 0px #e6e8ec;
    display: flex;
    padding: 5%;
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1;
    justify-content: space-between;
    align-items: center;
}

.filter-header p{
    font-weight: 700;
    font-size: 20px;
    line-height: 32px;
    color: #000000;
}

.filter-header button{
    font-size: 25px;
    line-height: 1;
    color: black;
    padding-right: 5%;
    z-index: 1;
}



.product-sort{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    box-shadow: inset 0px -1px 0px #E6E8EC;
    padding: 5% 0%;
}

.product-sort span{
    font-weight: bold;
    font-size: 1.1rem;
    line-height: 1.3;
    color: #0F0C38;
}

.product-sort select{
    width: 65%;
    padding: 2% 8% 2% 2%;
    border: 1px solid #F3EEFA;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08);
    border-radius: 100px;
    font-size: 1rem;
    line-height: 1.3;
    color: #0F0C38;
    height: unset;
}

.button-container{
    width: 75%;
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: space-around;
    box-shadow: inset 0px 1px 0px #E6E8EC;
    padding: 3% 0%;
    background-color: white;
    z-index: 1;
}

.button-container button{
    width: 44%;
}

.x{
    width: 20px;
    cursor: pointer;
}

@media screen and (min-width: 768px){
    .filters-page{
        justify-content: flex-start;
    }

    .filters-page-container{
        width: 20%;
    }

    .button-container{
        right: unset;
        width: 20%;
        left: 0;
    }

    .filters-container .product-sort{
        display: none;
    }
}

@media screen and (max-width: 767px){
    .filters-page{
        justify-content: flex-start;
        height: 100%;
    }

    .sticky.filters-page{
        height: 100%;
    }

    .button-container{
        right: unset;
        width: 75%;
        left: 0;
    }
}
</style>